import axios from 'axios';
import { API_BASE_URL } from './scanApi';

// Signale une visite au backend (best-effort). Le backend deduplique par IP et par jour :
// un rafraichissement (F5) le meme jour ne recompte pas le visiteur.
export const trackVisit = () =>
  axios.post(`${API_BASE_URL}/track/visit`, {}).catch(() => {});

// Langue recommandee selon le pays de l'IP ("fr" pour un pays francophone, sinon "en").
export const getGeoLocale = () => axios.get(`${API_BASE_URL}/track/locale`);

// Événement de tunnel (best-effort) : 'steam_click' | 'demo_start'. Sert à voir où les gens décrochent.
// sendBeacon pour que l'event parte même quand on quitte la page (redirection Steam).
export const trackEvent = (name) => {
  const url = `${API_BASE_URL}/track/event`;
  try {
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify({ name })], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return Promise.resolve();
    }
  } catch (e) {
    /* repli axios ci-dessous */
  }
  return axios.post(url, { name }).catch(() => {});
};
